import React from 'react'
import { useSelector } from 'react-redux'
import { Modules } from '../core'

import CardRegistrationCompleted from '../components/screens/CardRegistrationCompleted'

export default function CardRegistrationCompletedContainer() {
  const tenant = useSelector((state: Modules.AppState) => state.tenant)

  return <CardRegistrationCompleted tenant={tenant} />
}
